import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing.component';
import { MainComponent } from '../main/main.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: LandingComponent
      }
    ]
  },
];

export const LandingRoutes = RouterModule.forChild(routes);
